// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // API_URL: 'https://test-ekhtabr.seu.edu.sa/api/api',
  // API_URL: 'http://localhost:7300/api',
  API_URL: "https://dev-sas.cpt-it.com/api/api",
  Notfiy_URL: "https://test-ekhtabr.seu.edu.sa/api/notify",
  SSO: false,
  SSOUrl: "https://seuapps.seu.edu.sa/newservices/sso/sess.php",
  SSOLoginUrl: "https://seuapps.seu.edu.sa/newservices/sso/login-testl.php",
  SSOLogoutUrl: "https://sso.seu.edu.sa/oam/server/logout",
  HostName: "http://localhost:7300/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
